import makeErrorEnum from '../util/make-error-enum';

export default makeErrorEnum('restApi', [
  'AuthDeniedError',
  'AuthNotReadyError',
  'ApiNotConfiguredError',
]);
